window.whalewisdom.Stock = {
    show_combined:true,
    short_chart:null,
    columns:[

    ],
    init:function () {
        whalewisdom.Stock.columns.push({field:'name', index:'name', title:'Fund',sortable:true,
            formatter:whalewisdom.Stock.filer_formatter});
        whalewisdom.Stock.columns.push({field:'id', index:'name', title:'',sortable:false,
            formatter:whalewisdom.Stock.history_formatter});
        whalewisdom.Stock.columns.push({field:'city', index:'city', title:'City',sortable:true,
            visible:false});
        whalewisdom.Stock.columns.push({field:'state', index:'state', title:'State',sortable:true,
            visible:false});
        whalewisdom.Stock.columns.push({field:'current_shares',firstsortorder:'desc', title:'Shares Held<br/>or Principal Amt',sortable:true,
            index:'current_shares',  formatter:whalewisdom.Stock.format_number});
        whalewisdom.Stock.columns.push({field:'current_mv',firstsortorder:'desc', title:'Market Value',sortable:true,
            index:'current_mv',firstsortorder:'desc', formatter:whalewisdom.Stock.format_money});
        whalewisdom.Stock.columns.push({field:'current_percent_of_portfolio',  title:'% of<br/>Portfolio',sortable:true,
            firstsortorder:'desc',index:'current_percent_of_portfolio', formatter:whalewisdom.Stock.format_percent});
        whalewisdom.Stock.columns.push({field:'previous_percent_of_portfolio',  title:'Prior<br/>% of Portfolio',sortable:true,
            firstsortorder:'desc',index:'previous_percent_of_portfolio', formatter:whalewisdom.Stock.format_percent});
        whalewisdom.Stock.columns.push({field:'ranking', firstsortorder:'desc', title:'Ranking',sortable:true,
            index:'ranking', formatter:whalewisdom.Stock.ranking_formatter});
        whalewisdom.Stock.columns.push({field:'shares_change',firstsortorder:'desc', title:'Change in<br/>Shares',sortable:true,
            index:'shares_change', formatter:whalewisdom.Stock.change_formatter});
        whalewisdom.Stock.columns.push({field:'percent_ownership', index:'percent_ownership', title:'% Ownership',sortable:true,
             formatter:whalewisdom.Stock.ownership_formatter});
        whalewisdom.Stock.columns.push({field:'source_type', index:'source_type', title:'Source',sortable:true,
            visible:whalewisdom.Stock.show_combined});
        whalewisdom.Stock.columns.push({field:'source_date', index:'source_date', title:'Source Date',sortable:true,
            visible:whalewisdom.Stock.show_combined});
        whalewisdom.Stock.columns.push({field:'filing_date', index:'filing_date', title:'Date Reported',sortable:true,
            visible:whalewisdom.Stock.show_combined});
        whalewisdom.Stock.columns.push({
            field: 'quarter_first_owned',
                title: 'Qtr 1st<br/>Owned',
            sortable: true,
            index: 'quarter_id_owned',
            // width: 75,
            visible: true
        });
        whalewisdom.Stock.columns.push({
            field: 'avg_price',
                sortable: true,
                index: 'avg_price',
                title: 'Estimated<br/>Avg Price Paid',
                firstsortorder: 'desc',
                formatter: whalewisdom.Stock.format_percent
        });
       // window.whalewisdom.Stock.build_column_chooser();
        try{
            YChartsEmbed.drawChart([{"include": "true", "id": whalewisdom.Stock.ticker}], [{"include": "true", "id": "price"}]);
        }
        catch (err){

        }


        jQuery('.cmd-refresh').click(whalewisdom.Stock.refresh);
        jQuery('#cmd-combined-holders').click(whalewisdom.Stock.view_combined);
        jQuery('#cmd-stock-export').click(whalewisdom.Stock.export_to_excel);
        jQuery('#cmd-mf-holders-export').click(whalewisdom.Stock.mf_holder_to_excel);
        jQuery('#cmd-export-tsv').click(whalewisdom.Stock.export_to_excel_tsv);
        jQuery('#cmd-export-xlsx').click(whalewisdom.Stock.export_to_excel_xlsx);

        jQuery('.filter-change').change(function(e){
            //$(this).addClass('active');
            var justselectedval=$(this).val();
            //  if (d==6){
            //deselect all others
            var filters = jQuery('.filter-change');
            filters.filter(':checked').each(function () {
                var d=$(this).val();
                if (justselectedval!=d){
                    if (justselectedval=='6'){
                        $(this).prop('checked',false);
                        $(this).parent().removeClass('active');
                    }

                    else if (d=='6'){
                        $(this).prop('checked',false);
                        $(this).parent().removeClass('active');
                    }

                    //unselect
                }
            });
            //}
            $('.cmd-refresh ').click();
        });
     /*   jQuery('#quarter_one').val(whalewisdom.Stock.current_quarter_id);
        $('#quarter_one').change(function(e){
           var id=$(this).val();
           var current=window.whalewisdom.Stock.current_quarter_id;
           if (window.whalewisdom.Stock.show_combined && parseInt(id)<parseInt(current)){
               window.whalewisdom.Stock.view_combined();
           }
        });*/
        var c=whalewisdom.Stock.columns;
        var names=['Filer', 'City','State',
            'Shares Held<br/>or Principal Amt', 'Market Value', '% of<br/>Portfolio','Prior<br/>% of Portfolio',
            'Ranking', 'Change in<br/>Shares', '% Ownership',
        'Source', 'Source Date','Date Reported'];
        if (!jQuery('.visible-md').is(":visible") && !jQuery('.visible-lg').is(":visible")){
          /*  c[4].hidden=true;
            c[6].hidden=true;
            c[7].hidden=true;*/
        }
        $('#listings_table').bootstrapTable({
            url: whalewisdom.Stock.build_url(),
            sidePagination: 'server',
            pagination:true,
            paginationVAlign: 'both',
            onLoadError:function(arg1,arg2){
                $('#listings_table').bootstrapTable('updateFormatText', 'NoMatches', arg2.responseText);
            },
            sortName:'name',
            stickyHeader: true,
            sortOrder:'asc',
            showJumpto:true,
            pageSize:25,
           /* rowStyle:function(row, index) {
                return {
                    css: {"padding": "8px", "height": "37px"}
                };
            },*/
           // checkOnInit:true,
           // toggle:'table',
            showColumns:true,
            pageList:[10,25,50],
            totalField:'records',
            columns: c,
            cookie:true,
            cookieIdTable:"stock_holders",
            cookieExpire:'1y'
        });


        var mutual_fund_columns=[
            { field: 'event_date', title: 'Event Date', sortable: true, index: 'event_date'},
            { field: 'regName', title: 'Name', sortable: true, index: 'regName',formatter:whalewisdom.Stock.fund_formatter},
            { field: 'series_id', title: 'Series', sortable: true, index: 'series_id'},
            { field: 'seriesName', title: 'Series Name', sortable: true, index: 'seriesName',formatter:whalewisdom.Stock.series_formatter},
            { field: 'long_short', title: 'Long/Short', sortable: true, index: 'long_short'},
            { field: 'der_info', title: 'Derivative', sortable: true, index: 'der_info',sortable:false},
            { field: 'security_type', title: 'Type', sortable: true, index: 'security_type'},
            {
                field: 'current_shares',
                sortable: true,
                index: 'current_shares',
                title: 'Shares Held',
                firstsortorder: 'desc',
                formatter: whalewisdom.Stock.format_number
            },
            {
                field: 'current_mv',
                sortable: true,
                index: 'current_mv',
                title: 'Market Value',
                firstsortorder: 'desc',
                formatter: whalewisdom.Stock.format_money
            },
            {
                field: 'current_percent_of_portfolio',
                title: '% of<br/>Portfolio',
                sortable: true,
                firstsortorder: 'desc',
                index: 'current_percent_of_portfolio',
                formatter: whalewisdom.Stock.format_percent
            },
            {
                field: 'previous_percent_of_portfolio',
                title: 'Previous<br/>% of Portfolio',
                sortable: true,
                firstsortorder: 'desc',
                index: 'previous_percent_of_portfolio',
                formatter: whalewisdom.Stock.format_percent
            },
            {
                field: 'current_ranking',
                title: 'Rank',
                sortable: true,
                firstsortorder: 'desc',
                index: 'current_ranking',
                //   width: 75,
                formatter: whalewisdom.Stock.ranking_formatter
            },
            {
                field: 'shares_change',
                title: 'Change in<br/>Shares',
                sortable: true,
                firstsortorder: 'desc',
                index: 'shares_change',
                formatter: whalewisdom.Stock.change_formatter
            }

        ]

        $('#mutual_fund_holders_table').bootstrapTable({
            url: whalewisdom.Stock.build_mutual_fund_url(),
            sidePagination: 'server',
            pagination:true,
            paginationVAlign: 'both',
            onLoadError:function(arg1,arg2){
                $('#mutual_fund_holders_table').bootstrapTable('updateFormatText', 'NoMatches', arg2.responseText);
            },
            sortName:'name',
            stickyHeader: true,
            sortOrder:'asc',
            showJumpto:true,
            pageSize:25,
            showColumns:true,
            pageList:[10,25,50],
            totalField:'records',
            columns: mutual_fund_columns
        });

        jQuery('#summary_refresh_btn').click(function(e){
            whalewisdom.Stock.load_summary();
        });

        jQuery('.expand-heading').click(function (e) {
            var a = jQuery(this);
            var expandContent = a.parent().next('.expand-content');
            if (a.hasClass("expanded")) {
                expandContent.show(400).animate({}, 400);
                a.removeClass("expanded");
                a.addClass("collapsed");
                a.parent().parent().css("border", "solid 1px #222");
            }

            else {
                expandContent.hide(400);
                a.removeClass("collapsed");
                a.addClass("expanded");
                a.parent().parent().css("border", "none").
                                css("border-radius","15px");
            }
            e.preventDefault();
            return false;
        });
        jQuery(document).on( 'shown.bs.tab', 'a[data-toggle="tab"]', function (e) { // on tab selection event
            jQuery( "#chart_container" ).each(function() { // target each element with the .contains-chart class
                var chart = window.whalewisdom.Stock.metrics_chart;//Highcharts.chart(this, { /*Highcharts options*/ });//jQuery(this).highcharts(); // target the chart itself
                chart.reflow() // reflow that chart
            });
        })
       // whalewisdom.Stock.draw_chart();
        whalewisdom.Stock.init_self_reported();
        whalewisdom.Stock.load_summary();
        /*  if (whalewisdom.Stock.show_combined){
              jQuery('#cmd-combined-holders').html('Show Historical 13F Holdings');
              $('#combined-heading').css('display','block');
        //      $('#quarter_one').css('display','none');
         //     $('#qtr-1-label').css('display','none');
          }*/
    },
    load_summary:function(){
        if (!whalewisdom.Stock.stock_id)
            return;
        jQuery.ajax({
            url: "/stock/summary/"+whalewisdom.Stock.stock_id+"/"+jQuery('#summary_qtr1').val(),
            type: "GET",
            dataType: "html",
            success: function (data) {
                $('#summary_div').html(data);
            },
            error: function (xhr, status) {
                //alert("Sorry, there was a problem!");
            },
            complete: function (xhr, status) {
                //$('#showresults').slideDown('slow')
            }
        });
    },
    format_money:function(cellvalue,record){
        if (!cellvalue || isNaN(cellvalue))
            return "";
        return  numbro(cellvalue).formatCurrency({thousandSeparated:true,mantissa:0});
        //return numbro(cellvalue).format('($0,0a');
    },
    format_number:function(cellvalue,record){
        if (!cellvalue ||isNaN(cellvalue))
            return "";
        return numbro(cellvalue).format({thousandSeparated:true,negative:'parenthesis'});
       // return numbro(cellvalue).format('(0,0a');
    },
    format_percent:function(cellvalue,record){
        if (!cellvalue ||isNaN(cellvalue))
            return "";
        return numbro(cellvalue).format('0.00');
    },
    draw_chart:function(){
        jQuery.ajax({
            url: "/stock/get_current_chart_data?stock_id="+whalewisdom.Stock.stock_id+
            "&authenticity_token="+encodeURIComponent($('meta[name="csrf-token"]').attr("content")),
            success: function (data) {
                if (data.length<4)
                    return;
                Highcharts.theme = {
                    colors: ['#2b908f', '#90ee7e', '#f45b5b', '#7798BF', '#aaeeee', '#ff0066', '#eeaaee',
                        '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
                    chart: {
                        backgroundColor: {
                            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                            stops: [
                                [0, '#2a2a2b'],
                                [1, '#3e3e40']
                            ]
                        },
                        style: {
                            fontFamily: '\'Unica One\', sans-serif'
                        },
                        plotBorderColor: '#606063'
                    },
                    title: {
                        style: {
                            color: '#E0E0E3',
                            textTransform: 'uppercase',
                            fontSize: '20px'
                        }
                    },
                    subtitle: {
                        style: {
                            color: '#E0E0E3',
                            textTransform: 'uppercase'
                        }
                    },
                    xAxis: {
                        gridLineColor: '#707073',
                        labels: {
                            style: {
                                color: '#E0E0E3'
                            }
                        },
                        lineColor: '#707073',
                        minorGridLineColor: '#505053',
                        tickColor: '#707073',
                        title: {
                            style: {
                                color: '#A0A0A3'

                            }
                        }
                    },
                    yAxis: {
                        gridLineColor: '#707073',
                        labels: {
                            style: {
                                color: '#E0E0E3'
                            }
                        },
                        lineColor: '#707073',
                        minorGridLineColor: '#505053',
                        tickColor: '#707073',
                        tickWidth: 1,
                        title: {
                            style: {
                                color: '#A0A0A3'
                            }
                        }
                    },
                    tooltip: {
                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                        style: {
                            color: '#F0F0F0'
                        }
                    },
                    plotOptions: {
                        series: {
                            dataLabels: {
                                color: '#B0B0B3'
                            },
                            marker: {
                                lineColor: '#333'
                            }
                        },
                        boxplot: {
                            fillColor: '#505053'
                        },
                        candlestick: {
                            lineColor: 'white'
                        },
                        errorbar: {
                            color: 'white'
                        },
                        column: {
                            borderRadius: 5
                        }
                    },
                    legend: {
                        itemStyle: {
                            color: '#E0E0E3'
                        },
                        itemHoverStyle: {
                            color: '#FFF'
                        },
                        itemHiddenStyle: {
                            color: '#606063'
                        }
                    },
                    credits: {
                        style: {
                            color: '#666'
                        }
                    },
                    labels: {
                        style: {
                            color: '#707073'
                        }
                    },

                    drilldown: {
                        activeAxisLabelStyle: {
                            color: '#F0F0F3'
                        },
                        activeDataLabelStyle: {
                            color: '#F0F0F3'
                        }
                    },

                    navigation: {
                        buttonOptions: {
                            symbolStroke: '#DDDDDD',
                            theme: {
                                fill: '#505053'
                            }
                        }
                    },

                    // scroll charts
                    rangeSelector: {
                        buttonTheme: {
                            fill: '#505053',
                            stroke: '#000000',
                            style: {
                                color: '#CCC'
                            },
                            states: {
                                hover: {
                                    fill: '#707073',
                                    stroke: '#000000',
                                    style: {
                                        color: 'white'
                                    }
                                },
                                select: {
                                    fill: '#000003',
                                    stroke: '#000000',
                                    style: {
                                        color: 'white'
                                    }
                                }
                            }
                        },
                        inputBoxBorderColor: '#505053',
                        inputStyle: {
                            backgroundColor: '#333',
                            color: 'silver'
                        },
                        labelStyle: {
                            color: 'silver'
                        }
                    },

                    navigator: {
                        handles: {
                            backgroundColor: '#666',
                            borderColor: '#AAA'
                        },
                        outlineColor: '#CCC',
                        maskFill: 'rgba(255,255,255,0.1)',
                        series: {
                            color: '#7798BF',
                            lineColor: '#A6C7ED'
                        },
                        xAxis: {
                            gridLineColor: '#505053'
                        }
                    },

                    scrollbar: {
                        barBackgroundColor: '#808083',
                        barBorderColor: '#808083',
                        buttonArrowColor: '#CCC',
                        buttonBackgroundColor: '#606063',
                        buttonBorderColor: '#606063',
                        rifleColor: '#FFF',
                        trackBackgroundColor: '#404043',
                        trackBorderColor: '#404043'
                    },

                    // special colors for some of the
                    legendBackgroundColor: 'rgba(0, 0, 0, 0.5)',
                    background2: '#505053',
                    dataLabelsColor: '#B0B0B3',
                    textColor: '#C0C0C0',
                    contrastTextColor: '#F0F0F3',
                    maskColor: 'rgba(255,255,255,0.3)'
                };

// Apply the theme
                var show_stock_price=false;
                var show_shorts=false;
                var show_volume=false;
                for (var i=0;i<data.length;i++){
                    var rec=data[i];
                    if (rec.closing_price){
                        show_stock_price=true;
                        show_volume=true;
                    }
                    if (rec.avg_short_volume){
                        show_shorts=true;
                    }
                    if (show_shorts && show_stock_price)
                        break;

                }
                var num_axis=4
                var series_data=[];
                var s={name:"Net Buys",data:[],yAxis:0,type:"area",visible: false,turboThreshold:0};
                series_data.push(s);

                var s2={name:"Average 13F Ranking",data:[],yAxis:1,type:"line",turboThreshold:0, visible: false};
                series_data.push(s2);

                var s3={name:"# Funds Holding",data:[],yAxis:2,type:"line",visible: true,turboThreshold:0};
                series_data.push(s3);
                var s5={name:"Total 13F Shares Held(split-adjusted)",data:[],yAxis:3,type:"line",visible: false,turboThreshold:0};
                series_data.push(s5);
                var s4=null;
                if (show_stock_price){
                    num_axis+=1;
                    s4={name:"Closing Stock Price",data:[],yAxis:4,type:"line",visible: true,turboThreshold:0};
                    series_data.push(s4);
                }
                var s7=null;
                if (show_volume){
                    num_axis+=1;
                    s7={name:"Volume",data:[],yAxis:5,type:"line",visible: false,turboThreshold:0};
                    series_data.push(s7);
                }
                var s6=null;
                if (show_shorts){
                    num_axis+=1;
                    s6={name:"Short Volume",data:[],yAxis:6,type:"line",visible: false,turboThreshold:0};
                    series_data.push(s6);
                }
                var s8={name:"PUT/CALL Ratio",data:[],yAxis:num_axis,type:"line",visible: false,turboThreshold:0};
                series_data.push(s8)
                num_axis+=1;

                for (var j = 0; j < data.length; j++) {
                    var rec = data[j];
                   // var d =
                    s.data.push({name: rec.quarter_description,y: rec.net_buys});
                    s2.data.push({name: rec.quarter_description, y: rec.average_ranking});
                    s3.data.push({name: rec.quarter_description, y: rec.held_by});
                    if (show_stock_price){
                        s4.data.push({name: rec.quarter_description, y: parseFloat(rec.closing_price)});
                    }
                    if (show_volume){
                        s7.data.push({name: rec.quarter_description, y: parseFloat(rec.total_volume)});
                    }
                    s5.data.push({name: rec.quarter_description, y: rec.total_shares});
                    if (show_shorts){
                        s6.data.push({name: rec.quarter_description,
                            y: (rec.avg_short_volume ? parseFloat(rec.avg_short_volume)*1.0 : null)});
                    }
                    s8.data.push({name:rec.quarter_description,y: rec.put_call_ratio})
                }
                var y_axis=[
                    {title:{text:"Net Buys"},opposite: false,labels:{
                        formatter:function(){
                            return numbro(this.value).format('0.0a');
                        } }},
                    {title:{text:"Average Ranking"},opposite: false,labels:{
                        formatter:function(){
                            return numbro(this.value).format('0.0a')
                        } }},
                    {title:{text:"# Funds"},opposite: false,labels:{
                        formatter:function(){
                            return numbro(this.value).format('0.0a');
                        } }},
                    {title:{text:"Total 13F Shares"},opposite: false,labels:{
                        formatter:function(){
                            return numbro(this.value).format('0.0a');
                        } }}
                ];
                if (show_stock_price){
                    y_axis.push({title:{text:"Stock Price"},opposite: true,labels:{
                        formatter:function(){
                            return numbro(this.value).format('0.0a');
                        } }});

                }
                if (show_volume){
                    y_axis.push({title:{text:"Volume"},opposite: true,labels:{
                            formatter:function(){
                                return numbro(this.value).format('0.0a');
                            } }});
                }

                if (show_shorts){
                    y_axis.push({title:{text:"Short Volume"},opposite: true,labels:{
                        formatter:function(){
                            return numbro(this.value).format('0.0a');
                        } }});
                }
                y_axis.push({title:{text:"PUT/CALL Ratio"},opposite: true,visible:false,labels:{
                        formatter:function(){
                            return numbro(this.value).format('0.0a');
                        } }});

          //      whalewisdom.Stock.draw_short_chart();
                Highcharts.setOptions(Highcharts.theme);
                window.whalewisdom.Stock.metrics_chart=Highcharts.chart('chart_container', {

                    title: {
                        text: '13F Metrics'
                    },

                    subtitle: {
                        text: (!whalewisdom.Utilities.isSubscriber() ? " (subscribe to see data as far back as 2001)" : "")
                    },
                    xAxis: {
                        tickInterval: 90,
                        type: 'category'
                    },

                    yAxis: y_axis,
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    },

                    plotOptions: {
                        turboThreshold:0,
                        series: {
                         //   pointStart: 2010
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    tooltip: {
                        shared: true,
                        crosshairs: [true,true]
                    },
                    exporting: {
                        chartOptions: { // specific options for the exported image
                            plotOptions: {
                                series: {
                                    dataLabels: {
                                        enabled: true
                                    }
                                }
                            }
                        },
                        fallbackToExportServer: false
                    },
                    chart: {
                        // type:'bar',
                        zoomType: 'x'
                    },

                    series:series_data

                });
                jQuery('#chart_screen').removeClass('hidden');

                document.getElementById('chart_screen').addEventListener('click', function () {

                    window.whalewisdom.Stock.metrics_chart.fullscreen.toggle();

                });

                jQuery('#chart_excel').removeClass('hidden');

                document.getElementById('chart_excel').addEventListener('click', function () {

                    window.whalewisdom.Stock.metrics_excel();

                });

            }
        });
    },
    view_combined:function(e){
   /*   whalewisdom.Stock.show_combined=!whalewisdom.Stock.show_combined;
      if (whalewisdom.Stock.show_combined){
          jQuery('#cmd-combined-holders').html('Show Historical 13F Holdings');
          $('#combined-heading').css('display','block');
        // // $('#quarter_one').css('display','none');
          $('#qtr-1-label').css('display','none');
          jQuery("#listings_table").showCol(whalewisdom.Stock.columns[8].name);
          jQuery("#listings_table").showCol(whalewisdom.Stock.columns[9].name);
      }
      else
      {
      //    $('#quarter_one').css('display','');
      //    $('#qtr-1-label').css('display','');
          $('#combined-heading').css('display','none');
          jQuery('#cmd-combined-holders').html('Show Current Combined 13F/D/G Portfolio');
          jQuery("#listings_table").hideCol(whalewisdom.Stock.columns[8].name);
          jQuery("#listings_table").hideCol(whalewisdom.Stock.columns[9].name);
      }
      whalewisdom.Stock.refresh();*/
    },
    refresh:function (e) {

        jQuery("#listings_table").bootstrapTable('refresh',{url:whalewisdom.Stock.build_url()});
        //jQuery("#listings_table").jqGrid('setGridParam', {url:whalewisdom.Stock.build_url()}).trigger("reloadGrid");
    },
    build_change_filter:function () {
        var outArr = [];
        var filters = jQuery('.filter-change');
        filters.filter(':checked').each(function () {
            outArr.push(jQuery(this).val());
        });
        return outArr.join(",");
    },
    ranking_formatter:function (cellvalue, record) {
        var cell = record.ranking;
        if (!record.ranking)
            return '';
        if (record.ranking === 999999 && (!record.current_shares || record.current_shares==0))
            cell = 'Sold All';
        else if (record.ranking===999999)
            cell='';

        return cell;
    },
    ownership_formatter:function (cellvalue,  record) {
            var cell = record.percent_ownership;
            if (!cell || cell=='No Data' || cell=='N/A' || cell=='null'){
    return "";
            }
            else{
                cell=parseFloat(record.percent_ownership).toFixed(4)+"%";
            }

            return cell;
        },
    build_range:function(elem1,elem2){
        var from=parseFloat($(elem1).val());
        var to=parseFloat($(elem2).val());
        if (!from || !to)
            return "";
        return from+":"+to;
    },
    build_url:function () {
        var mv_range=whalewisdom.Stock.build_range('#mv_range_from','#mv_range_to');
        var perc_range=whalewisdom.Stock.build_range('#perc_range_from','#perc_range_to');
        var rank_range=whalewisdom.Stock.build_range('#rank_range_from','#rank_range_to');

        return '/stock/holdings?id=' + whalewisdom.Stock.stock_id + '&q1=' + jQuery('#quarter_one').val() +
            "&change_filter="+whalewisdom.Stock.build_change_filter()+
        "&mv_range="+mv_range+
        "&perc_range="+perc_range+
            "&rank_range="+rank_range+
            "&sc="+whalewisdom.Stock.show_combined+
            "&authenticity_token="+encodeURIComponent($('meta[name="csrf-token"]').attr("content"))
            //"&" + whalewisdom.Utilities.get_timestamp_cache();
    },
    build_mutual_fund_url:function(){
        return '/mutual_fund/current_holders?id=' + whalewisdom.Stock.stock_id;
    },
    update_query_url:function () {
        jQuery("#listings_table").bootstrapTable('refresh',{url:whalewisdom.Stock.build_url()});
        //jQuery("#listings_table").jqGrid('setGridParam', {url:whalewisdom.Stock.build_url()});   //.trigger("reloadGrid");
    },
    metrics_excel:function(){
        if (!whalewisdom.Utilities.isLoggedIn()){
            whalewisdom.Utilities.show_alert("Please Log In First",
                "Please create an account or log into your existing account first.  A premium subscription is also required for this feature.");
            return;
        }
        if (!whalewisdom.Utilities.isSubscriber()) {
            whalewisdom.Utilities.show_alert("Subscription Required", "This feature requires a subscription to use.");
            return;
        }
        var url = "/stock/get_current_chart_data_excel?stock_id="+whalewisdom.Stock.stock_id+
        "&authenticity_token="+encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
        window.location = url;
    },
    mf_holder_to_excel:function () {
            var id=parseInt($('#quarter_one').val());
            var allowed=false;
            //if (id>0 && (whalewisdom.Stock.current_quarter_id-9)>id)
            //    allowed=false;
            if (!whalewisdom.Utilities.isLoggedIn()){
             whalewisdom.Utilities.show_alert('Please Log In First',
                    'A premium account is now required to download this data.  Please create an account or log into your existing account first. ' +
                            'Premium subscribers may download ' +
                            "data as far back as 2001.   <a href='/mf-holders-sample.csv'>Download a sample file.</a>")
                return;
            }
            if (!allowed && !whalewisdom.Utilities.isSubscriber()) {
                whalewisdom.Utilities.show_alert("Subscription Required", "This feature requires a subscription to use.  <a href='/mf-holders-sample.csv'>Download a sample file.</a>");
                return;
            }
            var url = whalewisdom.Stock.build_mutual_fund_url().replace("/mutual_fund/current_holders", "/mutual_fund/current_holders_csv");
            window.location = url;
        },
    export_to_excel:function () {
        var id=parseInt($('#quarter_one').val());
        var allowed=false;
        if (id>0 && (whalewisdom.Stock.current_quarter_id-9)>id)
            allowed=false;
        if (allowed && !whalewisdom.Utilities.isLoggedIn()){
         whalewisdom.Utilities.show_alert('Please Log In First',
                'A premium account is now required to download this data.  Please create an account or log into your existing account first. ' +
                        'Premium subscribers may download ' +
                        "data as far back as 2001.   <a href='/stock-transactions-sample.csv'>Download a sample file.</a>")
            return;
        }
        if (!allowed && !whalewisdom.Utilities.isSubscriber()) {
            whalewisdom.Utilities.show_alert("Subscription Required", "This feature requires a subscription to use.  <a href='/stock-transactions-sample.csv'>Download a sample file.</a>");
            return;
        }
        var url = whalewisdom.Stock.build_url().replace("/stock/holdings", "/stock/holdings_csv");
        window.location = url;
    },
    export_to_excel_tsv: function () {
        var id=parseInt($('#quarter_one').val());
        var allowed=false;
        if (id>0 && (whalewisdom.Stock.current_quarter_id-9)>id)
            allowed=false;
        if (allowed && !whalewisdom.Utilities.isLoggedIn()){
             whalewisdom.Utilities.show_alert('Please Log In First',
                            'A premium account is now required to download this data.  Please create an account or log into your existing account first. ' +
                                    'Premium subscribers may download ' +
                                    "data as far back as 2001.   <a href='/stock-transactions-sample.tsv'>Download a sample file.</a>")
            return;
        }
        if (!allowed && !whalewisdom.Utilities.isSubscriber()) {
            whalewisdom.Utilities.show_alert("Subscription Required",
                "This feature requires a subscription to use. <a href='/stock-transactions-sample.tsv'>Download a sample file.</a>");
            return;
        }
        var url = whalewisdom.Stock.build_url().replace("/stock/holdings", "/stock/holdings_tsv");
        window.location = url;
    },
    export_to_excel_xlsx: function () {
        var id=parseInt($('#quarter_one').val());
        var allowed=false;
        if (id>0 && (whalewisdom.Stock.current_quarter_id-9)>id)
            allowed=false;
        if (allowed && !whalewisdom.Utilities.isLoggedIn()){
         whalewisdom.Utilities.show_alert('Please Log In First',
                        'A premium account is now required to download this data.  Please create an account or log into your existing account first. ' +
                                'Premium subscribers may download ' +
                                "data as far back as 2001.   <a href='/stock-transactions-sample.xlsx'>Download a sample file.</a>")
            return;
        }
        if (!allowed && !whalewisdom.Utilities.isSubscriber()) {
            whalewisdom.Utilities.show_alert("Subscription Required",
                "This feature requires a subscription to use. <a href='/stock-transactions-sample.xlsx'>Download a sample file.</a>");
            return;
        }
        var url = whalewisdom.Stock.build_url().replace("/stock/holdings", "/stock/holdings_xlsx");
        window.location = url;
    },
    filer_formatter:function (cellvalue, record) {
        var href = window.location.href.split("/");
        var cell = '<a href="/filer/' + record.permalink + '" title="' + record.name + '">' + record.name;
       // if (record.security_type != "SH")
       //     cell += "<span style='font-weight:bold;'>(" + record.security_type + ")</span>";
        cell += '</a>';
        if (record.security_type == "PRN")
            cell += "<span style='font-weight:bold;' title='PRN - principal amount on convertible debt securities'>(" + record.security_type + ")</span>";
        else if (record.security_type !='SH')
            cell += "<span style='font-weight:bold;'>(" + record.security_type + ")</span>";
        return cell;
    },
    series_formatter:function (cellvalue, record) {
        var href = window.location.href.split("/");
        var cell = '<a target="_blank" href="/dashboard2/mutual_fund/mutual_fund_holdings_view/' + record.seriesLei + '" title="' + record.seriesName + '">' + record.seriesName+"</a>";
        return cell;
    },
    fund_formatter:function (cellvalue, record) {
        var href = window.location.href.split("/");
        var cell = '<a target="_blank" href="/dashboard2/mutual_fund/mutual_fund_view/' + record.filer_permalink + '" title="' + record.regName + '">' + record.regName+"</a>";
        return cell;
    },
    history_formatter:function (cellvalue, record) {
        var href = window.location.href.split("/");
        var cell = '<a title="View Filer Ownership History" alt="View Filer Ownership History" class="history-link" href="' +
            '/filer/stock_history/' + record.permalink + "/" + href[href.length - 1] + '/' + '"></a>';

        return cell;
    },
    change_formatter:function (cellvalue, record) {
        var c = "";
        if (!record.shares_change){
            return "<span class=\"" + c + "\"></span>";
        }
        var desc = Math.abs(record.shares_change);
        desc = whalewisdom.Utilities.round_currency(desc);
        if (record.shares_change == 0) {
            desc = "No Change";
        }
        else if (record.shares_change < 0) {
            c = "decreasing";
        }
        else {
            c = "increasing";
        }
        return "<span class=\"" + c + "\">" + desc + "</span>";
    },
    build_column_chooser:function(){
        var chooser=$('#holders-column-chooser')
        var listing=$('#holders-columns');
        for (var i=0;i<whalewisdom.Stock.columns.length;i++){
            var column=whalewisdom.Stock.columns[i];
            //   var ele=$('<li class="list-group-item"></li>')
            if (!column.hidden)
                column.hidden=false;
            var chk=$('<button type="button" class="list-group-item">'+(column.hidden ? "Show " : "Hide ")+column.name+'</button>');
            //   var chk=$('<input type=checkbox "'+(column.hidden ? "" : 'checked="checked"')+'"/>');
            chk.data('column',column);
            // ele.append(chk);
            chk.click(function(e){
                var col=$(this).data('column');

                if (col.hidden){
                    jQuery("#listings_table").jqGrid('showCol',col.name);
                    $(this).text('Hide '+col.name);
                    col.hidden=false;
                }

                else{
                    jQuery("#listings_table").jqGrid('hideCol',col.name);
                    $(this).text('Show '+col.name);
                    col.hidden=true;
                }
            });
            listing.append(chk);
        }
        chooser.click(function(){
            listing.toggle();
        });
    },
    draw_short_chart(){
        var volume_data = {
            name: 'Short Volume',
            data: [],
            type: 'column',
            yAxis:0,
          //  color:'#0080ff'
        };
        var total_volume_data = {
            name: 'Other Volume',
            data: [],
            type: 'column',
            yAxis:0,
          //  color:'#efefef'
        };
        var price_data={
                name: 'Stock Price',
                data: [],
            yAxis:1,
            type: 'area',
         //   color: '#eb0f29',
            };
        for (var i=0;i<short_chart_data.length;i++){
            var cd=short_chart_data[i];
            var d3data = { x: null, y: null }
            var s = cd.short_date

                var darray = s.split('-')
                s = new Date(darray[0], parseInt(darray[1]) - 1, darray[2])

            d3data.x = s// .getTime();
            d3data.y = cd.sum_volume
            volume_data.data.push(d3data)
            price_data.data.push({x:s,y:cd.adj_close})
            total_volume_data.data.push({x:s,y:cd.total_volume-cd.sum_volume})
        }
        whalewisdom.Stock.short_chart=Highcharts.chart('short_chart', {
            chart: {
                zoomType: 'xy',
                //margin:0,
                //spacing:[0,0,0,0]
            },
            title: {
                text: '', margin:0
            },
            credits: {
                enabled: false
            },
            xAxis: {
                allowDecimals: false,
                labels: {
                    formatter: function () {
                        var d = new Date(this.value)

                        return d.getFullYear() + '-' + (d.getMonth() + 1)// d3.time.format('%Y-%m')(new Date(d));
                        // return this.value; // clean, unformatted number for year
                    }
                }
            },
            yAxis:[
                {gridLineWidth: 0,
                    title:{text:"Volume"},opposite: false,labels:{
                    enabled:true,
                        formatter:function(){
                            return numbro(this.value).format('0.0a');
                        } }},
                {gridLineWidth: 0,
                    title:{text:"Price"},opposite: true,labels:{enabled:true,
                        formatter:function(){
                            return numbro(this.value).format('0.0a');
                        } }}
            ],
            tooltip: {
                shared: true,
                formatter () {
                    var points = this.points
                    var pointsLength = points.length
                    var d = new Date(points[0].key)

                    var tooltipMarkup = pointsLength
                        ? '<span style="font-size: 10px">' +
                        d.getFullYear() +
                        '-' +
                        (d.getMonth() + 1) +
                        '-' +
                        (d.getDate())+
                        '</span><br/>'
                        : ''
                    var index
                    var yValueKwh

                    for (index = 0; index < pointsLength; index += 1) {
                        var ser=points[index].series;

                            yValueKwh = 0;//(points[index].y * 1.0).toFixed(2)

                                yValueKwh=points[index].y

                            yValueKwh=yValueKwh.toFixed(2)
                            tooltipMarkup +=
                                '<span style="color:' +
                                points[index].series.color +
                                '">\u25CF</span> ' +
                                points[index].series.name +
                                ': <b>' +
                                yValueKwh +
                                '</b><br/>'


                    }

                    return tooltipMarkup
                }
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: false
                    }
                }
            },
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 340
                    },
                    chartOptions: {
                        legend: {
                            align: 'center',
                            verticalAlign: 'top',
                            layout: 'horizontal'
                        }
                    }
                }]
            },
            legend: {
                layout: 'vertical',
                align: 'left',
                x: 120,
                verticalAlign: 'top',
                y: 10,
                floating: true,
                backgroundColor:
                    Highcharts.defaultOptions.legend.backgroundColor || // theme
                    'rgba(255,255,255,0.25)'
            },
            series: [volume_data,price_data,total_volume_data ]
        });
    },
    build_self_reported_url:function(){
        var td1=$("#sr_trading_date").val();
        var td2=$("#sr_trading_date2").val();
        return '/mutual_fund/self_reported_holdings?id=' + whalewisdom.Stock.stock_id+"&td1="+td1+"&td2="+td2;
    },
    update_self_reported_url:function () {
        jQuery("#self_reported_table").bootstrapTable('refresh',{url:whalewisdom.Stock.build_self_reported_url()});
        //jQuery("#listings_table").jqGrid('setGridParam', {url:whalewisdom.Stock.build_url()});   //.trigger("reloadGrid");
    },

    sr_stock_formatter:function (cellvalue, record) {
        var c = record.company+" ("+record.ticker+")";
        c="<a target='_blank' href=\"/stock/"+record.permalink+"\">"+c+"</a>"

        return c;
    },
    sr_change_formatter:function (cellvalue, record) {
        var c = "";
        if (record.change_in_shares<0 && record.current_shares==0)
            c="SOLD OUT"
        else if (record.change_in_shares<0)
            c="REDUCED"
        else if (record.change_in_shares>0 && record.previous_shares==0)
            c="NEW"
        else if (record.change_in_shares>0)
                c="ADDED"
        else
            c="NO CHANGE"


        return c;
    },
    init_self_reported:function(){
        var table=jQuery('#self_reported_table');
        if (table.length==0)
            return;
        jQuery('.cmd-refresh-self-reported').click(whalewisdom.Stock.update_self_reported_url);
        /*

        select date1,date2,stock_id,company,ticker,current_mv,previous_mv,
current_weight,previous_weight,current_shares,previous_shares,s.permalink
from (
select t1.trading_date as date1, t2.trading_date as date2,
t1.stock_id, t1.company, t1.ticker, t1.mv as current_mv,
t2.mv as previous_mv, t1.weight as current_weight, t2.weight as previous_weight,
t1.shares as current_shares,
t2.shares as previous_shares
         */
        var columns=[
            { field: 'date1', title: 'Current Date', sortable: false, index: 'date1'},
            { field: 'date2', title: 'Previous Date', sortable: false, index: 'date2'},
            { field: 'company', title: 'Stock', sortable: true, index: 'company',formatter:whalewisdom.Stock.sr_stock_formatter},
            { field: 'change_in_shares', title: 'Change', sortable: true, index: 'change_in_shares',formatter: whalewisdom.Stock.sr_change_formatter},
            {
                field: 'current_shares',
                sortable: true,
                index: 'current_shares',
                title: 'Shares Held',
                firstsortorder: 'desc',
                formatter: whalewisdom.Stock.format_number
            },
            {
                field: 'previous_shares',
                sortable: true,
                index: 'previous_shares',
                title: 'Previous Shares',
                firstsortorder: 'desc',
                formatter: whalewisdom.Stock.format_number
            },
            {
                field: 'current_mv',
                sortable: true,
                index: 'current_mv',
                title: 'Market Value',
                firstsortorder: 'desc',
                formatter: whalewisdom.Stock.format_money
            },
            {
                field: 'current_weight',
                title: '% of<br/>Portfolio',
                sortable: true,
                firstsortorder: 'desc',
                index: 'current_weight',
                formatter: whalewisdom.Stock.format_percent
            },
            {
                field: 'previous_weight',
                title: 'Previous<br/>% of Portfolio',
                sortable: true,
                firstsortorder: 'desc',
                index: 'previous_weight',
                formatter: whalewisdom.Stock.format_percent
            },

        ]

        $('#self_reported_table').bootstrapTable({
            url: whalewisdom.Stock.build_self_reported_url(),
            sidePagination: 'server',
            pagination:true,
            paginationVAlign: 'both',
            onLoadError:function(arg1,arg2){
                $('#self_reported_table').bootstrapTable('updateFormatText', 'NoMatches', arg2.responseText);
            },
            sortName:'name',
            stickyHeader: true,
            sortOrder:'asc',
            showJumpto:true,
            pageSize:25,
            showColumns:true,
            pageList:[10,25,50],
            totalField:'records',
            columns: columns
        });
    }
}
jQuery(function () {
    whalewisdom.Stock.init();
});